import { IS_NATIVE_APP } from '../config/environment'
import { shareDownloadFile } from './nativeFeatures'

export async function downloadBlob(
	blob: Blob,
	filename: string,
): Promise<boolean> {
	if (IS_NATIVE_APP) return shareDownloadFile(blob, filename)
	const url = URL.createObjectURL(blob)
	const link = document.createElement('a')
	link.href = url
	link.download = filename
	document.body.append(link)
	link.click()
	link.remove()
	window.setTimeout(() => URL.revokeObjectURL(url), 1000)
	return true
}
